<template>
  <div id="app">
	<!-- <home></home> -->
	<zsyyingxiao></zsyyingxiao>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import home from './components/home.vue'
import zsyyingxiao from './components/zsyYingXiao.vue'

export default {
  name: 'app',
  components: {
    HelloWorld,
	home,
	zsyyingxiao
  }
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
